const MONTHS_LONG = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro"
];

/**
 * Formata data_publicacao ISO para exibição no portal de novidades.
 * Usa timezone local do browser (Date).
 *
 * @param {string} isoString
 * @returns {{ date: string, time: string, full: string, relative: string }}
 */
export function formatDateTimeBR(isoString) {
  try {
    const d = new Date(isoString);
    if (Number.isNaN(d.getTime())) {
      return { date: isoString, time: "", full: isoString, relative: "" };
    }
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, "0");
    const mins = String(d.getMinutes()).padStart(2, "0");
    const monthName = MONTHS_LONG[d.getMonth()];

    return {
      date: `${day}/${month}/${year}`,
      time: `${hours}:${mins}`,
      full: `${day} de ${monthName} de ${year} às ${hours}:${mins}`,
      relative: `${day} de ${monthName}, ${year}`
    };
  } catch (e) {
    return { date: isoString, time: "", full: isoString, relative: "" };
  }
}
